import { createAsyncThunk } from '@reduxjs/toolkit';
import { getThreadVideoSessions } from 'store/chat/services/getThreadVideoSessions.service';

export const getThreadVideoSessionsThunk = createAsyncThunk(
  'chat/getThreadVideoSessions',
  async ({ lastEvaluatedKey, limit } = {}, { getState }) => {
    const { thread } = getState().chatSlice;
    const result = await getThreadVideoSessions(
      thread,
      lastEvaluatedKey,
      limit
    );
    return result;
  }
);

// Asks the API again what the newest calls carry of their notes. A notes
// frame says only that the notes moved on, because it reaches everyone
// reading the thread; the API answers with the notes themselves only to the
// people in the call and holders of the all-notes permission.
export const refreshVideoSessionNotesThunk = createAsyncThunk(
  'chat/refreshVideoSessionNotes',
  async ({ limit } = {}, { getState }) => {
    const { thread } = getState().chatSlice;
    const result = await getThreadVideoSessions(thread, undefined, limit);
    return result;
  }
);
